/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Broker6Inputs */

const cs_role_broker6 = /** @type {(inputs: Role_Broker6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléř`)
};

const en_role_broker6 = /** @type {(inputs: Role_Broker6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broker`)
};

/**
* | output |
* | --- |
* | "Broker" |
*
* @param {Role_Broker6Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
const role_broker6 = /** @type {((inputs?: Role_Broker6Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Broker6Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_broker6(inputs)
	return cs_role_broker6(inputs)
});
export { role_broker6 as "role_BROKER" }